import React, { Component } from 'react'
import { withFirebase } from '../auth/firebase/context';
import styles from '../css/LinkButton.module.css';

class LogoutButton extends Component {
    render() {
        const { firebase } = this.props;

        return (
            <button className={styles.linkButton} type="button" onClick={firebase.signOut}>
                Logout
            </button>
        )
    }
}

export default withFirebase(LogoutButton);